module.exports = __webpack_public_path__ + "static/media/img-center.84cd1969.png";